import Text from "common/Typography/Text";
import Modal from "common/Modal/Modal";
import { displayResultMessage } from "utils/misc";
import { GroupData, MarketplaceSubGroup } from "@shared/types";
import { sharedLib } from "@shared/services/shared.service";

interface JoinGroupFreeTrialModalProps {
  visible: boolean;
  closeModal: () => void;
  groupData?: GroupData | MarketplaceSubGroup;
}

const JoinGroupFreeTrialModal = ({
  visible,
  closeModal,
  groupData,
}: JoinGroupFreeTrialModalProps) => {
  const [subscribeToGroupFreeTrial, { isLoading }] =
    sharedLib.sharedApi.configuration.useSubscribeToGroupFreeTrialMutation();

  const onFreeTrialClick = () => {
    if (groupData) {
      const id = "id" in groupData ? groupData.id : groupData.group_id;
      displayResultMessage(
        subscribeToGroupFreeTrial({ sub_group_id: id }).unwrap(),
        "Successfully subscribed to group free trial."
      ).then(closeModal);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={closeModal}
      title="Are you sure?"
      destroyOnHidden={true}
      okText="Yes"
      onOk={onFreeTrialClick}
      okButtonProps={{ loading: isLoading }}
      cancelButtonProps={{ disabled: isLoading }}
    >
      <Text as="div">
        <div>
          If you proceed with this action, your trial subscription to{" "}
          {groupData?.name} will start immediately and will expire in 7 days.
        </div>
        <div style={{ marginTop: 8 }}>Are you sure you wish to continue?</div>
      </Text>
    </Modal>
  );
};

export default JoinGroupFreeTrialModal;
